<script>
import {mapGetters} from 'vuex'

import {Routes} from '@/router'

export default {
  computed: {
    ...mapGetters([
      'user'
    ]),
    console_has_errors() {
      const messages = this.$store.state.log_messages
      return messages.filter(message => message.level === 'error').length
    },
    docs_are_open() {
      return this.$route.path.split('/')[1] === Routes.Docs.name
    },
    is_mini: {
      get: function() { return this.$route.name === Routes.Dashboard.name },
      set: () => {}
    },
    width() {
      return this.docs_are_open ? 860 : 560
    }
  },
  data() {
    return {
      prev_route: null,
      Routes,
      tab_idx: 0,
      tabs: [
        {icon: 'chart-area', label: 'Apps', route: Routes.Apps},
        {icon: 'terminal', label: 'Log', route: Routes.Logs},
        {icon: 'cog', label: 'Settings', route: Routes.Settings},
        {icon: 'book-open', label: 'Docs', route: Routes.Docs}
      ]
    }
  },
  methods: {
    on_close_click() {
      this.$router.push(Routes.Dashboard)
    },
    on_open_click() {
      if(this.prev_route) {
        this.$router.push(this.prev_route)
      } else {
        this.$router.push(Routes.Apps)
      }
    }
  },
  name: 'candela-sidebar',
  watch: {
    $route(to, from) {
      if(to.name === Routes.Dashboard.name) {
        this.prev_route = from
      }
    },
    tab_idx(curr, prev) {
      if(curr === undefined) this.tab_idx = prev
    }
  }
}
</script>
<template>
<v-navigation-drawer v-if='user' :mini-variant.sync='is_mini'
  :width='width' class='d-flex flex-column flex-grow-1 align-items-stretch'
  app right permanent disable-resize-watcher stateless>

  <!-- Mini mode -->
  <div v-if='is_mini' @click='on_open_click'
    class='menu-icon-container d-flex justify-center align-center'>
    <v-icon small>fa-bars</v-icon>
  </div>

  <v-list v-if='is_mini' class='mini-list py-0'>
    <v-list-item-group v-model='tab_idx'>
      <v-tooltip v-for='(tab, i) in tabs' :key='i' color='secondary' left>
        <template v-slot:activator='{on}'>
          <v-list-item v-on='on' :value='i' :to='tab.route'
            active-class='active-mini-list-item'>
            <v-badge v-if='tab.route.name === Routes.Logs.name'
              :value='console_has_errors'
              color='error' dot overlap>
              <v-icon small class='mr-2'>{{`fa-${tab.icon}`}}</v-icon>
            </v-badge>
            <v-icon v-else small class='mr-2'>{{`fa-${tab.icon}`}}</v-icon>
          </v-list-item>
        </template>
        <span>{{tab.label}}</span>
      </v-tooltip>
    </v-list-item-group>
  </v-list>

  <!-- Expanded -->
  <div v-if='!is_mini' class='d-flex top-container'>
    <v-tabs  v-model='tab_idx' height='63'
      class='flex-grow-0' :next-icon='null' fixed-tabs>
      <v-tab v-for='(tab, i) in tabs' :key='i' :to='tab.route'>
        <v-icon small class='mr-3'>{{`fa-${tab.icon}`}}</v-icon>
        <span>{{tab.label}}</span>
      </v-tab>
    </v-tabs>
    <div @click='on_close_click'
      class='menu-close-icon-container d-flex justify-center align-center px-6'>
      <v-icon small>fa-times</v-icon>
    </div>
  </div>
  <router-view/>
</v-navigation-drawer>
</template>

<style lang='sass' scoped>
.active-mini-list-item
  background: transparent
  background-color: transparent
  color: var(--v-primary-base) !important

.menu-icon-container
  border-bottom: 1px solid var(--v-grey-darken6)
  height: 64px

.top-container
  border-bottom: 1px solid var(--v-grey-darken6)

.theme--dark
  .menu-close-icon-container
    border-left: 1px solid var(--v-grey-darken6)

  .menu-icon-container, .menu-close-icon-container
    &:hover
      background-color: var(--v-grey-darken6)
      cursor: pointer

  .v-navigation-drawer
    background-color: var(--v-grey-darken9)

.theme--light
  .menu-close-icon-container
    background-color: white
    border-left: 1px solid var(--v-grey-base)

  .menu-icon-container,  .menu-close-icon-container
    &:hover
      background-color: var(--v-grey-lighten6)
      cursor: pointer

  .v-navigation-drawer
    background-color: var(--v-grey-lighten9)

::v-deep .v-navigation-drawer__content, .v-navigation-drawer
  display: flex
  flex-direction: column
  flex-grow: 1
  overflow: visible !important

::v-deep .v-window__container, .v-window__container, .v-window-item
  max-height: 100%
  min-height: 100%
</style>
